/**
 * Address API endpoint schemas
 *
 * Export all Zod schemas and types for address-related API endpoints
 */

// Create address
export {
  CreateAddressRequestSchema,
  CreateAddressResponseSchema,
  type CreateAddressRequest,
  type CreateAddressResponse,
} from './create';

// Edit address (includes AddressIdParamSchema shared across endpoints)
export {
  AddressIdParamSchema,
  EditAddressRequestSchema,
  EditAddressResponseSchema,
  type AddressIdParam,
  type EditAddressRequest,
  type EditAddressResponse,
} from './edit';

// Deactivate address
export {
  DeactivateAddressResponseSchema,
  type DeactivateAddressResponse,
} from './deactivate';

// Set default address
export {
  SetDefaultAddressResponseSchema,
  type SetDefaultAddressResponse,
} from './set-default';

// List addresses
export {
  GetAddressesResponseSchema,
  type GetAddressesResponse,
} from './list';
